const features = [
  { icon: "ri-dashboard-3-line", title: "空间数据洞察", desc: "覆盖POI全量数据、区域经济图谱、产业集聚分布等核心数据层，实时更新，支撑金融机构对区域市场的深度研判与业务决策。", tags: ["POI全量数据", "区域经济图谱", "实时数据更新"], color: "from-cyan-500 to-teal-400" },
  { icon: "ri-building-4-line", title: "对公业务拓客", desc: "基于企业全量数据与产业链图谱，精准定位目标法人客户群，多维度分析企业资金流、经营状况，辅助客户经理高效触达高价值对公客户。", tags: ["企业画像分析", "产业链图谱", "精准营销触达"], color: "from-cyan-500 to-teal-400" },
  { icon: "ri-user-follow-line", title: "零售业务拓客", desc: "融合人口热力、消费行为、居住分布等空间数据，构建个人客户画像模型，识别区域高净值人群，驱动零售金融业务精准获客。", tags: ["人口热力分析", "消费行为洞察", "高净值识别"], color: "from-amber-500 to-orange-400" },
  { icon: "ri-shield-check-line", title: "抵押贷款辅助", desc: "整合房产交易、地块价值、区域配套等多源空间数据，提供抵押物价值评估辅助、区域市场走势分析，降低贷款风险敞口。", tags: ["房产价值评估", "地块分析", "风险辅助决策"], color: "from-emerald-500 to-emerald-400" },
  { icon: "ri-map-pin-2-line", title: "网点选址优化", desc: "综合人流热力、竞品网点布局、商圈活跃度、交通可达性等要素，构建网点选址评分模型，优化物理渠道布局策略。", tags: ["人流热力分析", "竞品布局监测", "选址评分模型"], color: "from-cyan-500 to-blue-500" },
];

const dataSupport = [
  { icon: "ri-database-2-line", title: "企业全量数据", desc: "经营画像" },
  { icon: "ri-hotel-line", title: "商务楼宇数据", desc: "企业分布" },
  { icon: "ri-map-pin-line", title: "POI全量数据", desc: "配套分析" },
  { icon: "ri-building-2-line", title: "园区数据", desc: "产业集聚" },
  { icon: "ri-store-2-line", title: "沿街商铺数据", desc: "商圈活力" },
];

export default function FSFeaturesV2() {
  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-cyan-600 tracking-widest uppercase mb-2 block">Platform Features</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">五大核心金融服务能力</h2>
          <p className="text-slate-500 text-sm max-w-2xl mx-auto">空间数据洞察、对公拓客、零售拓客、抵押辅助、网点选址，覆盖金融机构业务全链路</p>
        </div>
        <div className="flex flex-wrap justify-center gap-6 mb-16">
          {features.map(f => (
            <div key={f.title} className="bg-white rounded-2xl p-6 border border-slate-100 hover:border-cyan-200 transition-all cursor-pointer group w-full sm:w-[340px] lg:w-[370px]">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br ${f.color} mb-4 group-hover:scale-105 transition-transform`}>
                <i className={`${f.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-slate-800 font-semibold text-base mb-2">{f.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed mb-4">{f.desc}</p>
              <div className="flex flex-wrap gap-1.5">
                {f.tags.map(t => <span key={t} className="text-xs bg-cyan-50 border border-cyan-100 text-cyan-700 px-2 py-0.5 rounded-full">{t}</span>)}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-[#0a1e3a] to-[#0d2a4a] rounded-2xl px-8 py-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <div className="text-xs font-semibold text-cyan-300 tracking-widest uppercase mb-1">Data Support</div>
            <h3 className="text-white font-bold text-lg">多维空间数据支撑 · 精准金融决策</h3>
          </div>
          <div className="flex items-center gap-6">
            {dataSupport.map(d => (
              <div key={d.title} className="flex flex-col items-center text-center bg-white/10 rounded-xl px-4 py-3 border border-white/15 min-w-[90px]">
                <div className="w-8 h-8 flex items-center justify-center text-blue-300 mb-2">
                  <i className={`${d.icon} text-xl`}></i>
                </div>
                <div className="text-white font-semibold text-sm">{d.title}</div>
                <div className="text-white/50 text-xs mt-0.5">{d.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
